import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var CurrentUser = require("lib/account/CurrentUser");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("users/admins/code_table_preference.scss");

//create a search filter for the token that depends
//on the current admin being in a school org OR a district org.
function createFilterForOrgID(admin){
    if (admin.primary_district_org_id){
        return {
            "district_org_id": admin.primary_district_org_id,
            "all_district_tokens": true
        }
    }
    else if (admin.primary_school_org_id) {
        return {"school_org_id":admin.primary_school_org_id}
    }
}

//returns list of admin ids from a list of tokens
function subAdminIDsFromTokens(tokens){
    var userIDs = []
    tokens.forEach(token => {
        if (token.user){
            userIDs.push(token.user)
        }
    })
    return userIDs
}

@connect(
    (state,props) =>{
        var admin = RosterSelectors.admin({state, id:CurrentUser.get().id})
        var filter = createFilterForOrgID(admin)
        //tokens w no email were manually entered by Claire
        //no filter here...
        var tokens = _.filter(RosterSelectors.upgradeTokens({state}), token=>{
            return token.contact_email
        })
        
        var loading = RosterSelectors.isLoadingUpgradeTokens({state}) || RosterSelectors.isLoadingAdmins({state})

        var tokensBySchool = _.groupBy(tokens, 'contact_school')
        
        function orderByLastName (a, b){
            if (a.contact_name && b.contact_name){
                //Not sure how many spaces might be in a name, just grabbing the 
                //last word in the name to be safe
                var splitNameA = a.contact_name.split(" ")
                var lastNameA = splitNameA[splitNameA.length - 1]

                var splitNameB = b.contact_name.split(" ")
                var lastNameB = splitNameB[splitNameB.length - 1]

                if (lastNameA > lastNameB){
                    return 1
                }
                else if (lastNameB > lastNameA){
                    return -1
                }
                else return 0
            }
            //cases where one name is undefined.
            if (a.contact_name && !b.contact_name){
                return -1
            }
            else if ( b.contact_name && !a.contact_name){
                return 1
            }
            //both undefined
            else return 0
            
        }
        
        // find the start plan by school
        var currentPlanStartBySchool = {}
        //sort the tables by teacher last name, and gather most recent start date by school.
        for (var school in tokensBySchool){
            tokensBySchool[school].sort(orderByLastName)
            
            var startDates = _.pluck(tokensBySchool[school], "start_date")
            var mostRecentPlanStart
            startDates.forEach(stringDate=>{
                var newDate = new Date(stringDate)
                if (!mostRecentPlanStart) { mostRecentPlanStart = newDate }
                else if (newDate > mostRecentPlanStart) { mostRecentPlanStart = newDate}
            })
            currentPlanStartBySchool[school] = mostRecentPlanStart
        }

        return {
            admin: admin,
            tokens: tokens,
            loading: loading,
            tokensBySchool: tokensBySchool,
            currentPlanStartBySchool: currentPlanStartBySchool
        }
    },
    (dispatch, props)=>({
        populateData: function() {
            //STEP 1: Grab logged in admin
            var admin = CurrentUser.get()
            //STEP 2: Grab all tokens for the current admins org.
            var filter = createFilterForOrgID(admin)
            if (filter){
                dispatch(RosterActions.fetchUpgradeTokens({
                    filters:{...filter},
                    embeds:['upgrade_token.user_info']
                }))
            }
        }
    })
)
@providePopulateData()
class UpgradeCodeTablePreference extends React.Component{
    constructor(props){
        super()
        autobind(this)
        this.state = {}
        LuckyOrangeClient.tagComponent("AdminCodeTable");
    }

    renderTables(){
        var display =_.map(this.props.tokensBySchool, tokens=>{
            return this.renderSchoolTable(tokens)
        })
        return display
    }

    renderSchoolTable(tokens){
        var planStart = this.props.currentPlanStartBySchool[tokens[0].contact_school]
        var table = (
            <div className="codeTable" key={tokens[0].contact_school}>
                <h3> {tokens[0].contact_school}</h3>
                <p> Plan start: {planStart.toLocaleDateString()}</p>
                <table className="table table-bordered">
                    <tbody>
                        {this.renderTableHeader()}
                        {this.renderTableRows(tokens)}
                    </tbody>
                </table>
            </div>
        )
        return table
    }

    renderTableHeader(){
        return (
            <tr>
                <th className="nameHeader">
                    Name
                </th>
                <th className="emailHeader">
                    Email
                </th>
                <th className="codeHeader">
                    Activation Code
                </th>
                <th className="codeStatusHeader">
                    Code Status
                </th>
                <th className="onboardingHeader">
                    Students Added
                </th>
            </tr>
        )
    }

    renderTableRows(tokens){
        // Filter tokens by start date
        var schoolName = tokens[0].contact_school
        var currentPlanStart = this.props.currentPlanStartBySchool[schoolName]
        
        var planStartRange = new Date(currentPlanStart.getFullYear(), currentPlanStart.getMonth() - 1 , currentPlanStart.getDate())
        var planEndRange = new Date(currentPlanStart.getFullYear(), currentPlanStart.getMonth() + 1 , currentPlanStart.getDate())

        var currentTokens = _.filter(tokens, token => {
            var tokenDate = new Date(token.start_date).getTime()
            return tokenDate > planStartRange.getTime() && tokenDate < planEndRange.getTime()
        })

        var rows = currentTokens.map(token=>{
            return (
                <tr key={token.code}>
                    <td>
                        {token.contact_name? token.contact_name : "--"}
                    </td>
                    <td>
                        {token.contact_email? token.contact_email: "--"}
                    </td>
                    <td>
                        {token.code? token.code : "--"}
                    </td>
                    <td>
                        {this.generateStatusText(token)}
                    </td>
                    <td>
                        {this.generateOnboardingStatus(token)}
                    </td>
                </tr>
            )
        })
        return rows
    }


    generateStatusText(token){
        if (token.user_info && !_.isEmpty(token.user_info)){
            var text = <span className="success">Redeemed</span>
        } else { 
            text = 
                <div>
                    <span className="fail">Not redeemed </span>
                </div>

        }
        return text
    }

    generateOnboardingStatus(token){
        var adminInfo = token.user_info
        
        // If no user is connected to the token
        if (_.isEmpty(adminInfo)){ return "Pending" }
        
        //If the subadmin is an admin (not a teacher), they don't have primary students.
        if (!adminInfo.role || adminInfo.role == "adminRole" || adminInfo.role == "districtAdminRole") { return "N/A" } 
        
        // If they're a teacher, check if they added students
        if (adminInfo['add_students']){
            return <span className="success">Yes</span>
        } else {
            return <span className="fail"> No </span>
        }
    }
    
    render(){
        if (this.props.loading){
            return (
                <div className="spinnerContainer">
                    <Spinner/>
                </div>
            )
        }
        if (_.isEmpty(this.props.tokensBySchool)){
            return (
                <div>
                    <span>No upgrade codes exist for your school or district </span>
                </div>
            )
        }
        var helpText = 
            <a href="https://whooosreading.zendesk.com/hc/en-us/articles/360024144952" target="_blank">
                Need help with activation codes? Learn more <Glyphicon icon="new-window" />
            </a>
        var tables = this.renderTables()
        return (
            <div>
                {helpText}
                {tables}
            </div>  
        )     
    }
}

UpgradeCodeTablePreference.WrappedComponent.propTypes = PageStrictPropTypes({

	// All data from @connect
    
	loading: PropTypes.bool,
	//signed in admin
    admin: PropTypes.object,
    //all other subadmins that have a token in their district
    subAdmins: PropTypes.array,
    //all tokens in the district
    tokens: PropTypes.array,
    //tokens organized into tables
    tokensBySchool: PropTypes.object,
	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = UpgradeCodeTablePreference;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/UpgradeCodeTablePreference.js